// import { createActions, createReducer } from "reduxsauce";

// /* =========================================================
//    INITIAL STATE
// ========================================================= */

// export const INITIAL_STATE = {
//     list: {
//         data: [],
//         loading: false,
//         success: false,
//         error: null,
//     },

//     create: {
//         data: null,
//         loading: false,
//         success: false,
//         error: null,
//     },

//     update: {
//         data: null,
//         loading: false,
//         success: false,
//         error: null,
//     },

//     testEmail: {
//         data: null,
//         loading: false,
//         success: false,
//         error: null,
//     },
// };

// /* =========================================================
//    ACTIONS
// ========================================================= */

// const { Types, Creators } = createActions(
//     {
//         // GET EMAIL TEMPLATES
//         getEmailTemplates: ["resolve"],
//         getEmailTemplatesRequest: null,
//         getEmailTemplatesSuccess: ["data"],
//         getEmailTemplatesFailure: ["error"],

//         // CREATE EMAIL TEMPLATE
//         createEmailTemplate: ["payload", "resolve"],
//         createEmailTemplateRequest: null,
//         createEmailTemplateSuccess: ["data"],
//         createEmailTemplateFailure: ["error"],

//         // UPDATE EMAIL TEMPLATE
//         updateEmailTemplate: ["id", "payload", "resolve"],
//         updateEmailTemplateRequest: null,
//         updateEmailTemplateSuccess: ["data"],
//         updateEmailTemplateFailure: ["error"],

//         // SEND TEST EMAIL
//         sendTestEmail: ["payload", "resolve"],
//         sendTestEmailRequest: null,
//         sendTestEmailSuccess: ["data"],
//         sendTestEmailFailure: ["error"],
//     },
//     {
//         prefix: "cb/admin/emailManager/",
//     }
// );

// export const types = Types;
// export const actions = Creators;

// /* =========================================================
//    GET EMAIL TEMPLATES
// ========================================================= */

// const fetchRequest = (state) => ({
//     ...state,

//     list: {
//         ...state.list,
//         loading: true,
//         success: false,
//         error: null,
//     },
// });

// const fetchSuccess = (state, { data }) => ({
//     ...state,

//     list: {
//         data,
//         loading: false,
//         success: true,
//         error: null,
//     },
// });

// const fetchFailure = (state, { error }) => ({
//     ...state,

//     list: {
//         ...state.list,
//         loading: false,
//         success: false,
//         error,
//     },
// });

// /* =========================================================
//    CREATE EMAIL TEMPLATE
// ========================================================= */

// const createRequest = (state) => ({
//     ...state,

//     create: {
//         data: null,
//         loading: true,
//         success: false,
//         error: null,
//     },
// });

// const createSuccess = (state, { data }) => ({
//     ...state,

//     create: {
//         data,
//         loading: false,
//         success: true,
//         error: null,
//     },

//     // Keep list in sync with newly created template
//     list: {
//         ...state.list,
//         data: [...state.list.data, data],
//     },
// });

// const createFailure = (state, { error }) => ({
//     ...state,

//     create: {
//         data: null,
//         loading: false,
//         success: false,
//         error,
//     },
// });

// /* =========================================================
//    UPDATE EMAIL TEMPLATE
// ========================================================= */

// const updateRequest = (state) => ({
//     ...state,

//     update: {
//         data: null,
//         loading: true,
//         success: false,
//         error: null,
//     },
// });

// const updateSuccess = (state, { data }) => ({
//     ...state,

//     update: {
//         data,
//         loading: false,
//         success: true,
//         error: null,
//     },

//     // Replace the existing template in the list
//     list: {
//         ...state.list,

//         data: state.list.data
//             .map((template) =>
//                 template.id === data.id ? data : template
//             )
//             .sort((a, b) => a.name.localeCompare(b.name)),
//     },
// });

// const updateFailure = (state, { error }) => ({
//     ...state,

//     update: {
//         data: null,
//         loading: false,
//         success: false,
//         error,
//     },
// });

// /* =========================================================
//    SEND TEST EMAIL
// ========================================================= */

// const testEmailRequest = (state) => ({
//     ...state,

//     testEmail: {
//         data: null,
//         loading: true,
//         success: false,
//         error: null,
//     },
// });

// const testEmailSuccess = (state, { data }) => ({
//     ...state,

//     testEmail: {
//         data,
//         loading: false,
//         success: true,
//         error: null,
//     },
// });

// const testEmailFailure = (state, { error }) => ({
//     ...state,

//     testEmail: {
//         data: null,
//         loading: false,
//         success: false,
//         error,
//     },
// });

// /* =========================================================
//    HANDLERS
// ========================================================= */

// export const HANDLERS = {
//     // GET
//     [Types.GET_EMAIL_TEMPLATES_REQUEST]: fetchRequest,
//     [Types.GET_EMAIL_TEMPLATES_SUCCESS]: fetchSuccess,
//     [Types.GET_EMAIL_TEMPLATES_FAILURE]: fetchFailure,

//     // CREATE
//     [Types.CREATE_EMAIL_TEMPLATE_REQUEST]: createRequest,
//     [Types.CREATE_EMAIL_TEMPLATE_SUCCESS]: createSuccess,
//     [Types.CREATE_EMAIL_TEMPLATE_FAILURE]: createFailure,

//     // UPDATE
//     [Types.UPDATE_EMAIL_TEMPLATE_REQUEST]: updateRequest,
//     [Types.UPDATE_EMAIL_TEMPLATE_SUCCESS]: updateSuccess,
//     [Types.UPDATE_EMAIL_TEMPLATE_FAILURE]: updateFailure,

//     // SEND TEST EMAIL
//     [Types.SEND_TEST_EMAIL_REQUEST]: testEmailRequest,
//     [Types.SEND_TEST_EMAIL_SUCCESS]: testEmailSuccess,
//     [Types.SEND_TEST_EMAIL_FAILURE]: testEmailFailure,
// };

// /* =========================================================
//    REDUCER
// ========================================================= */

// export default createReducer(INITIAL_STATE, HANDLERS);

import { createActions, createReducer } from "reduxsauce";

/* =========================================================
   INITIAL STATE
========================================================= */

export const INITIAL_STATE = {
    list: {
        data: [],
        loading: false,
        success: false,
        error: null,
    },

    create: {
        data: null,
        loading: false,
        success: false,
        error: null,
    },

    update: {
        data: null,
        loading: false,
        success: false,
        error: null,
    },

    testEmail: {
        data: null,
        loading: false,
        success: false,
        error: null,
    },

    sendEmail: {
        data: null,
        loading: false,
        success: false,
        error: null,
    },
};

/* =========================================================
   ACTIONS
========================================================= */

const { Types, Creators } = createActions(
    {
        // GET EMAIL TEMPLATES
        getEmailTemplates: ["resolve"],
        getEmailTemplatesRequest: null,
        getEmailTemplatesSuccess: ["data"],
        getEmailTemplatesFailure: ["error"],

        // CREATE EMAIL TEMPLATE
        createEmailTemplate: ["payload", "resolve"],
        createEmailTemplateRequest: null,
        createEmailTemplateSuccess: ["data"],
        createEmailTemplateFailure: ["error"],

        // UPDATE EMAIL TEMPLATE
        updateEmailTemplate: ["id", "payload", "resolve"],
        updateEmailTemplateRequest: null,
        updateEmailTemplateSuccess: ["data"],
        updateEmailTemplateFailure: ["error"],

        // SEND TEST EMAIL
        sendTestEmail: ["payload", "resolve"],
        sendTestEmailRequest: null,
        sendTestEmailSuccess: ["data"],
        sendTestEmailFailure: ["error"],

        // SEND EMAIL
        sendEmail: ["payload", "resolve"],
        sendEmailRequest: null,
        sendEmailSuccess: ["data"],
        sendEmailFailure: ["error"],
    },
    {
        prefix: "cb/admin/emailManager/",
    }
);

export const types = Types;
export const actions = Creators;

/* =========================================================
   GET EMAIL TEMPLATES
========================================================= */

const fetchRequest = (state) => ({
    ...state,

    list: {
        ...state.list,
        loading: true,
        success: false,
        error: null,
    },
});

const fetchSuccess = (state, { data }) => ({
    ...state,

    list: {
        data,
        loading: false,
        success: true,
        error: null,
    },
});

const fetchFailure = (state, { error }) => ({
    ...state,

    list: {
        ...state.list,
        loading: false,
        success: false,
        error,
    },
});

/* =========================================================
   CREATE EMAIL TEMPLATE
========================================================= */

const createRequest = (state) => ({
    ...state,

    create: {
        data: null,
        loading: true,
        success: false,
        error: null,
    },
});

const createSuccess = (state, { data }) => ({
    ...state,

    create: {
        data,
        loading: false,
        success: true,
        error: null,
    },

    list: {
        ...state.list,
        data: [...state.list.data, data],
    },
});

const createFailure = (state, { error }) => ({
    ...state,

    create: {
        data: null,
        loading: false,
        success: false,
        error,
    },
});

/* =========================================================
   UPDATE EMAIL TEMPLATE
========================================================= */

const updateRequest = (state) => ({
    ...state,

    update: {
        data: null,
        loading: true,
        success: false,
        error: null,
    },
});

const updateSuccess = (state, { data }) => ({
    ...state,

    update: {
        data,
        loading: false,
        success: true,
        error: null,
    },

    list: {
        ...state.list,

        data: state.list.data
            .map((template) =>
                template.id === data.id ? data : template
            )
            .sort((a, b) => a.name.localeCompare(b.name)),
    },
});

const updateFailure = (state, { error }) => ({
    ...state,

    update: {
        data: null,
        loading: false,
        success: false,
        error,
    },
});

/* =========================================================
   SEND TEST EMAIL
========================================================= */

const testEmailRequest = (state) => ({
    ...state,

    testEmail: {
        data: null,
        loading: true,
        success: false,
        error: null,
    },
});

const testEmailSuccess = (state, { data }) => ({
    ...state,

    testEmail: {
        data,
        loading: false,
        success: true,
        error: null,
    },
});

const testEmailFailure = (state, { error }) => ({
    ...state,

    testEmail: {
        data: null,
        loading: false,
        success: false,
        error,
    },
});

/* =========================================================
   SEND EMAIL
========================================================= */

const sendEmailRequest = (state) => ({
    ...state,

    sendEmail: {
        data: null,
        loading: true,
        success: false,
        error: null,
    },
});

const sendEmailSuccess = (state, { data }) => ({
    ...state,

    sendEmail: {
        data,
        loading: false,
        success: true,
        error: null,
    },
});

const sendEmailFailure = (state, { error }) => ({
    ...state,

    sendEmail: {
        data: null,
        loading: false,
        success: false,
        error,
    },
});

/* =========================================================
   HANDLERS
========================================================= */

export const HANDLERS = {
    // GET
    [Types.GET_EMAIL_TEMPLATES_REQUEST]: fetchRequest,
    [Types.GET_EMAIL_TEMPLATES_SUCCESS]: fetchSuccess,
    [Types.GET_EMAIL_TEMPLATES_FAILURE]: fetchFailure,

    // CREATE
    [Types.CREATE_EMAIL_TEMPLATE_REQUEST]: createRequest,
    [Types.CREATE_EMAIL_TEMPLATE_SUCCESS]: createSuccess,
    [Types.CREATE_EMAIL_TEMPLATE_FAILURE]: createFailure,

    // UPDATE
    [Types.UPDATE_EMAIL_TEMPLATE_REQUEST]: updateRequest,
    [Types.UPDATE_EMAIL_TEMPLATE_SUCCESS]: updateSuccess,
    [Types.UPDATE_EMAIL_TEMPLATE_FAILURE]: updateFailure,

    // SEND TEST EMAIL
    [Types.SEND_TEST_EMAIL_REQUEST]: testEmailRequest,
    [Types.SEND_TEST_EMAIL_SUCCESS]: testEmailSuccess,
    [Types.SEND_TEST_EMAIL_FAILURE]: testEmailFailure,

    // SEND EMAIL
    [Types.SEND_EMAIL_REQUEST]: sendEmailRequest,
    [Types.SEND_EMAIL_SUCCESS]: sendEmailSuccess,
    [Types.SEND_EMAIL_FAILURE]: sendEmailFailure,
};

/* =========================================================
   REDUCER
========================================================= */

export default createReducer(INITIAL_STATE, HANDLERS);